import { Component } from '@theme/component';
class CoastalProductEdit extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.controller = new AbortController();
    try { this.saved = JSON.parse(localStorage.getItem('rt-coastal-saved') || '[]'); } catch { this.saved = []; }
    if (!Array.isArray(this.saved)) this.saved = [];
    this.addEventListener('click', this.handleClick, { signal: this.controller.signal });
    this.addEventListener('keydown', this.handleKey, { signal: this.controller.signal });
    this.refreshSaved();
  }
  updatedCallback() { super.updatedCallback(); this.refreshSaved(); }
  disconnectedCallback() { super.disconnectedCallback(); this.controller?.abort(); }
  handleClick = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const tab = target?.closest('[data-panel]');
    if (tab && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      event.preventDefault();
      this.selectPanel(tab);
    }
    const save = target?.closest('[data-save]');
    if (save) {
      const handle = save.dataset.save;
      if (this.saved.some(item => item.handle === handle)) this.saved = this.saved.filter(item => item.handle !== handle);
      else this.saved.push({ handle, title: save.dataset.title, url: save.dataset.url, image: save.dataset.image });
      this.persist();
    }
    const remove = target?.closest('[data-remove]');
    if (remove) { this.saved = this.saved.filter(item => item.handle !== remove.dataset.remove); this.persist(); this.querySelector('.rt-coastal-saved summary')?.focus(); }
  };
  handleKey = (event) => {
    if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    const tabs = [...this.querySelectorAll('[data-panel]')];
    const index = tabs.indexOf(event.target);
    if (index < 0) return;
    event.preventDefault();
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length-1 : (index+(event.key === 'ArrowRight' ? 1 : -1)+tabs.length)%tabs.length;
    this.selectPanel(tabs[next]); tabs[next].focus();
  };
  selectPanel(tab) {
    for (const link of this.querySelectorAll('[data-panel]')) { if (link === tab) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current'); }
    for (const panel of this.querySelectorAll('.rt-coastal-products__panel')) panel.hidden = panel.id !== tab.dataset.panel;
  }
  persist() { try { localStorage.setItem('rt-coastal-saved',JSON.stringify(this.saved)); } catch {} this.refreshSaved(); }
  refreshSaved() {
    for (const button of this.querySelectorAll('[data-save]')) button.setAttribute('aria-pressed',String(this.saved.some(item => item.handle === button.dataset.save)));
    const list = this.querySelector('[data-saved-list]');
    if (!list) return;
    list.replaceChildren();
    for (const item of this.saved) {
      if (!item || typeof item.url !== 'string' || !item.url.startsWith('/products/')) continue;
      const li=document.createElement('li'), a=document.createElement('a'), img=document.createElement('img'), label=document.createElement('span'), button=document.createElement('button');
      a.href=item.url; label.textContent=String(item.title || item.handle); a.append(label);
      if (typeof item.image === 'string' && /^https?:\/\/|^\/\//.test(item.image)) { img.src=item.image;img.alt='';img.width=50;img.height=60;a.prepend(img); }
      button.type='button';button.dataset.remove=item.handle;button.textContent='×';button.setAttribute('aria-label',(this.dataset.removeLabel || '__product__').replace('__product__',String(item.title || item.handle)));li.append(a,button);list.append(li);
    }
    this.querySelector('[data-saved-count]').textContent=String(this.saved.length);
    this.querySelector('[data-saved-empty]').hidden=this.saved.length>0;
  }
}
if (!customElements.get('coastal-product-edit')) customElements.define('coastal-product-edit',CoastalProductEdit);
